<template>
  <div>
    <v-row>
      <v-col>
        <iframe src="https://meajuda.gitbook.io/apoio-suporte/comunicados/comunicados" width="100%" height="740px"
          frameborder="0"></iframe>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { verificarSessao } from "../../utils/utils";

export default {
  name: "Inicio",
  data() {
    return {
    };
  },
  async created() {
    window.addEventListener("offline", () => (this.loading = true));
    window.addEventListener("online", () => (this.loading = false));
    /**
     *
     */
    verificarSessao(() => { });
    setTimeout(verificarSessao, 1 * 60000);
  },
  methods: {
  },
};
</script>

<style>
body {
  margin: 15px !important;
}
</style>
